module.exports = __webpack_public_path__ + "static/media/image-1.a532ffca.png";